import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { PurchasableModule } from '../hooks/usePurchases';

interface ModulePreview {
  name: string;
  emoji: string;
  gradient: string;
  isPaid: boolean;
  purchaseId?: PurchasableModule;
}

const modulePreviews: ModulePreview[] = [
  { name: 'Soft', emoji: '🍺', gradient: 'from-blue-500 to-blue-700', isPaid: false },
  { name: 'Hard', emoji: '💀', gradient: 'from-violet-600 to-purple-800', isPaid: true, purchaseId: 'hard' },
  { name: 'Débat', emoji: '🔥', gradient: 'from-green-500 to-green-800', isPaid: true, purchaseId: 'roulette' },
  { name: 'Coquin', emoji: '🌶️', gradient: 'from-red-500 to-red-800', isPaid: true, purchaseId: 'coquin' },
];

interface HomeProps {
  isModulePurchased: (module: PurchasableModule) => boolean;
}

export default function Home({ isModulePurchased }: HomeProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 via-[#0d1117] to-black flex flex-col items-center justify-between p-6 overflow-y-auto safe-top safe-bottom safe-x">
      {/* Top section with logo */}
      <div className="flex-1 flex flex-col items-center justify-center pt-8">
        {/* Logo */}
        <div className="text-7xl mb-4 animate-float">🍻</div>

        {/* App name */}
        <h1 className="font-display font-black text-4xl text-white text-center mb-2">
          Spin & Drink
        </h1>
        <p className="font-body text-white/40 text-sm text-center mb-8">
          Le jeu à boire ultime entre amis
        </p>

        {/* Start button */}
        <button
          onClick={() => navigate('/players')}
          className="px-12 py-4 rounded-2xl bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white font-display font-bold text-lg btn-press shadow-[0_4px_30px_rgba(124,58,237,0.4)] animate-pulse-glow"
        >
          Commencer 🎉
        </button>
      </div>

      {/* Module preview cards */}
      <div className="w-full max-w-md mt-10 mb-4">
        <p className="font-display font-semibold text-white/50 text-xs uppercase tracking-widest mb-4 text-center">
          4 modes de jeu
        </p>

        <div className="grid grid-cols-2 gap-3">
          {modulePreviews.map((module) => {
            const isLocked = module.isPaid && module.purchaseId && !isModulePurchased(module.purchaseId);

            return (
              <div
                key={module.name}
                className={`relative rounded-2xl bg-gradient-to-br ${module.gradient} p-4 text-center overflow-hidden`}
              >
                <div className="text-3xl mb-1">{module.emoji}</div>
                <p className="font-display font-bold text-white text-sm">{module.name}</p>
                {isLocked && (
                  <>
                    <div className="absolute inset-0 bg-black/40 rounded-2xl" />
                    <span className="absolute top-2 right-2 text-sm">🔒</span>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
